<template>
  <div class="homeMain">
    <div class="homeLeft">
      <div class="map-top">
        <!-- <img
                    src="../../../assets/supervise/lefttop.png"
                    class="companyImg"
                    alt=""
                    srcset=""
                /> -->
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle1"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle2"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle3"
        />
        <img
          src="../../../assets/supervise/borderRight.png"
          alt=""
          srcset=""
          class="trangleRight"
        />

        <div id="serveMap" class="serveMap"></div>
      </div>
      <div class="map-bottom">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="old-left">
          <p>老年人分析</p>
          <div class="analyse">
            <div class="analyse-left">
              <div id="ageData"></div>
            </div>
            <div class="analyse-right">
              <div id="moneyData"></div>
            </div>
          </div>
        </div>

        <div class="old-right">
          <p>基本情况</p>
          <ul>
            <li>
              <p>养老院</p>
              <div>
                <span>{{ ylydata }}</span
                ><img src="../../../assets/supervise/bg.png" />
              </div>
            </li>
            <li>
              <p>房屋</p>
              <div>
                <span>{{ houseNum }}</span
                ><img src="../../../assets/supervise/bg.png" />
              </div>
            </li>
            <li>
              <p>建筑面积</p>
              <div>
                <span>{{ builtArea }}</span
                ><img src="../../../assets/supervise/bg.png" />
              </div>
            </li>
            <li>
              <p>院部员工</p>
              <div>
                <span>{{ staffCount }}</span
                ><img src="../../../assets/supervise/bg.png" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="homeCenter">
      <div class="serveObj">
        <img
          src="../../../assets/supervise/serveObj1.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="serveObjTop">
          <p class="sertitle">养老概况</p>
          <div class="serveBox">
            <div class="serveOther" @click="getServeTypes(1, ylydata)">
              <img src="../../../assets/supervise/zhyly.png" alt="" srcset="" />
              <p>
                <span class="name">智慧养老院</span><br />
                <span class="nums">{{ ylydata }}</span>
              </p>
            </div>
            <div class="serveOther" @click="getServeTypes(2, ruyuanOldMan1)">
              <img src="../../../assets/supervise/pold.png" alt="" srcset="" />
              <p>
                <span class="name">入院老人</span><br />
                <span class="nums" style="color: #2e9eff">{{
                  ruyuanOldMan
                }}</span>
              </p>
            </div>
          </div>
          <p class="sertitle today">今日智能监管</p>
          <div class="serveBox">
            <div class="serveOther">
              <img
                src="../../../assets/supervise/outold.png"
                alt=""
                srcset=""
              />
              <p>
                <span class="name">出院老人</span><br />
                <span class="nums" style="color: #fefe00">{{
                  chuyuanOldMan
                }}</span>
              </p>
            </div>
            <div class="serveOther">
              <img
                src="../../../assets/supervise/timeon.png"
                alt=""
                srcset=""
              />
              <p>
                <span class="name">逾期未归</span><br />
                <span class="nums" style="color: #975fe4">{{ outtime }}</span>
              </p>
            </div>
            <div class="serveOther">
              <img src="../../../assets/supervise/wayon.png" alt="" srcset="" />
              <p>
                <span class="name">请假</span><br />
                <span class="nums" style="color: #fbb828">{{ qingjia }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="demographic">
        <img
          src="../../../assets/supervise/demographicIcon.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">入院老人</p>
        <div id="hospitalOld"></div>
      </div>
    </div>
    <div class="homeRight">
      <div class="companyServe">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="compayTop">
          <p class="companyName">整改记录</p>
        </div>
        <div class="companyHead" style="margin-bottom: 8px">
          <span class="item2">整改机构</span>
          <span class="item">整改主题</span>
          <span class="item">整改内容</span>
          <span class="item">整改时间</span>
        </div>
        <div class="oversHead">
          <div
            class="companyHead nocolorHead"
            v-for="(item, id) in bullData"
            :key="id"
          >
            <span class="item2">{{ item.mechanismName }}</span>
            <span class="item">{{ item.theme }}</span>
            <span class="item">{{ item.content }}</span>
            <span class="item">{{ item.rectificationTime }}</span>
          </div>
        </div>
      </div>
      <div class="serveStation">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="over">
          <p class="serveTitle">食品监督</p>
          <!-- <div class="prism-player" id="player-con"></div> -->
          <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${this.vodelist[0].sequence}/${this.vodelist[0].channel}.live&autoplay=1&audio=1&accessToken=${this.vodelist[0].token}&templete=2`"
            width="94%"
            height="300px"
            style="margin: 20px 3%"
            id="ysopen"
            allowfullscreen
          >
          </iframe>
          <p class="serveTitle" style="padding-top: 0">院内监督</p>
          <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${this.vodelist[1].sequence}/${this.vodelist[1].channel}.live&autoplay=1&audio=1&accessToken=${this.vodelist[1].token}&templete=2`"
            width="94%"
            height="300px"
            style="margin: 20px 3%"
            id="ysopen"
            allowfullscreen
          >
          </iframe>
          <!-- <p class="serveTitle" style="padding-top: 0">消防安全</p>
                    <video
                        id="myvideo1"
                        :src="videoUrl"
                        style="height: 200px; width: 94%; margin: 20px 3%"
                        ref="videoId"
                        autoplay="true"
                        controls
                        muted
                    ></video> -->
        </div>
      </div>
    </div>
    <!-- 弹窗 start -->
    <div class="maskModel" v-if="isMasked">
      <div class="yearMoney">
        <p class="name">基本信息</p>
        <img
          src="../../../assets/supervise/normalCanle.png"
          alt=""
          srcset=""
          @click="closeInfo"
          class="maskClose"
        />
      </div>
      <div class="personFlex">
        <img
          v-if="maskdata.photo == null"
          src="../../../assets/supervise/photo.png"
          class="img"
          alt=""
          srcset=""
        />
        <img v-else :src="maskdata.photo" class="img" alt="" srcset="" />
        <div class="personConent">
          <ul>
            <li>姓名：{{ maskdata.name }}</li>
            <li>性别：{{ maskdata.gender == 1 ? "女" : "男" }}</li>
            <li>年龄：{{ maskdata.age }}</li>
            <li>手机号码：{{ maskdata.phone }}</li>
            <li>地址：{{ maskdata.address }}</li>
          </ul>
        </div>
      </div>
      <div class="yearMoney noflex">
        <p class="name">入院信息</p>
      </div>
      <div class="ruyuanInfo">
        <ul>
          <li>入院时间: {{ maskdata.intoTime }}</li>
          <li>有无试住: {{ maskdata.intoType == 0 ? "无" : "有" }}</li>
          <li>计费开始日期: {{ maskdata.chargingTime }}</li>
        </ul>
      </div>
      <div class="yearMoney noflex">
        <p class="name">健康信息</p>
        <div class="ruyuanInfo">
          <ul>
            <li>
              饮食禁忌:
              <span v-if="maskdata.dietTaboo == 0">糖</span>
              <span v-if="maskdata.dietTaboo == 1">海鲜</span>
              <span v-if="maskdata.dietTaboo == 2">蛋类</span>
              <span v-if="maskdata.dietTaboo == 3">豆制品</span>
              <span v-if="maskdata.dietTaboo == 4">其他</span>
            </li>
            <li>
              自理情况:
              <span v-if="maskdata.selfCare == 0">较差，完全需要别人照顾</span>
              <span v-if="maskdata.selfCare == 1"
                >一般，有些事情需要别人照顾</span
              >
              <span v-if="maskdata.selfCare == 2"
                >较好，一般不需要别人照顾</span
              >
              <span v-if="maskdata.selfCare == 3">很好，还可以照顾别人</span>
            </li>
            <li>
              健康情况:
              <span v-if="maskdata.health == 0">身体健康</span>
              <span v-if="maskdata.health == 1">高血压</span>
              <span v-if="maskdata.health == 2">冠心病</span>
              <span v-if="maskdata.health == 3">脑卒中</span>
              <span v-if="maskdata.health == 4">糖尿病</span>
              <span v-if="maskdata.health == 5">类风湿</span>
              <span v-if="maskdata.health == 6">脑出血</span>
              <span v-if="maskdata.health == 7">高血脂</span>
              <span v-if="maskdata.health == 8">系统性狼疮</span>
              <span v-if="maskdata.health == 9">恶性肿瘤</span>
              <span v-if="maskdata.health == 10">恶性肿瘤</span>
              <span v-if="maskdata.health == 11">结核病</span>
              <span v-if="maskdata.health == 12">肝炎</span>
              <span v-if="maskdata.health == 13">其他法定传染病</span>
              <span v-else>其他</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      title="养老院详情"
      :visible.sync="dialogVisible"
      width="75%"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="name-per">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          class="name-list"
          @click="changeIdx(item.id)"
        >
          <div>
            <div
              class="name-title"
              :class="{
                changeColor: controlAddContent == item.id,
              }"
            >
              <div></div>
              <div><i class="el-icon-circle-check"></i></div>
              <div></div>
            </div>
            <div class="name-bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <el-form
        ref="addFormRef"
        :modal-append-to-body="false"
        :model="addForm"
        label-width="140px"
        disabled
      >
        <div v-show="controlAddContent == 1">
          <div class="addBox">
            <div>
              <el-form-item label="机构名称:" prop="mechanismName">
                <el-input
                  v-model="addForm.mechanismName"
                  placeholder="请输入"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构类型:" prop="mechanismType">
                <el-select
                  v-model="addForm.mechanismType"
                  placeholder="请选择"
                  style="width: 400px"
                >
                  <el-option label="养老机构" value="0"></el-option>
                  <el-option label="日间照料中心" value="1"></el-option>
                  <el-option
                    label="城乡居家养老机构(幸福院)"
                    value="2"
                  ></el-option>
                  <el-option label="合作服务商" value="3"></el-option>
                  <el-option label="其他" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运行方式:" prop="operation">
                <el-select
                  v-model="addForm.operation"
                  placeholder="请选择"
                  style="width: 400px"
                >
                  <el-option label="村委会管理" value="0"></el-option>
                  <el-option label="协会管理" value="1"></el-option>
                  <el-option label="委托管理" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务热线:" prop="hotline">
                <el-input
                  v-model="addForm.hotline"
                  placeholder="请输入"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
              <el-form-item label="核定医疗床位数:" prop="bedsNumber">
                <el-input
                  v-model="addForm.bedsNumber"
                  placeholder="请输入"
                  style="width: 400px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
            <div class="uploadAvatar">
              <el-upload
                disabled
                :show-file-list="false"
                :action="actionUrl"
                list-type="picture-card"
              >
                <img v-if="addForm.head" :src="addForm.head" class="avatar" />
                <i v-else class="el-icon-plus"></i>
                <!-- avatar-uploader-icon -->
              </el-upload>
              <div class="uploadBtn" style="text-align: center">上传图片</div>
            </div>
          </div>
          <div class="addBox">
            <div>
              <el-form-item label="建设状态:" prop="build">
                <el-select
                  v-model="addForm.build"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="新建" value="1"></el-option>
                  <el-option label="改扩建" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系方式:" prop="phone">
                <el-input
                  v-model="addForm.phone"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="学历:">
                <!-- <el-input v-model="addForm.education" placeholder="请输入"></el-input> -->
                <el-select
                  v-model="addForm.education"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="高中以下" value="0"></el-option>
                  <el-option label="专科" value="1"></el-option>
                  <el-option label="本科" value="2"></el-option>
                  <el-option label="研究生" value="3"></el-option>
                  <el-option label="博士" value="4"></el-option>
                  <el-option label="硕士" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人姓名:">
                <el-input
                  v-model="addForm.legalPerson"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="法人联系方式:"
                prop="legalPersonPhone"
                :rules="[
                  {
                    pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                    message: '手机格式错误',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  v-model="addForm.legalPersonPhone"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
            </div>
            <div style="margin-left: 30px">
              <el-form-item label="机构负责人:" prop="chargePerson">
                <el-input
                  v-model="addForm.chargePerson"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="idNumber">
                <el-input
                  v-model="addForm.idNumber"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="民族:">
                <el-select
                  v-model="addForm.nation"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in nation"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="法人身份证号:"
                prop="legalPersonIds"
                :rules="[
                  {
                    pattern:
                      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                    message: '身份证号格式错误',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  v-model="addForm.legalPersonIds"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别:">
                <el-select
                  v-model="addForm.sex"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <!-- <el-form-item label="上传图片:" prop="photo">
                        <template v-if='addForm.photo !=null'>
                            <el-image
                                v-for="(item, index) in addForm.photo"
                                :key="index"
                                style="
                                    width: 120px;
                                    height: 120px;
                                    margin: 10px;
                                    z-index: 9999999999999;
                                "
                                :src="item"
                                :preview-src-list="addForm.photo"
                            >
                            </el-image>
                        </template>
                       <el-upload
                            v-else
                            :action="actionUrl"
                            list-type="picture-card"
                            :file-list="photo"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item> -->
        </div>
        <!-- 运营信息 -->
        <div v-show="controlAddContent == 2">
          <span style="color: #409eff">运营信息</span>
          <p class="hengxian"></p>
          <div class="addBox">
            <div>
              <el-form-item label="运营模式:">
                <el-select
                  v-model="addForm.operationMode"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="公办公营" value="1"></el-option>
                  <el-option label="公办民营" value="2"></el-option>
                  <el-option label="民办民营" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="医疗服务方式:">
                <el-select
                  v-model="addForm.serviceMode"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="内设医务室" value="0"></el-option>
                  <el-option label="与医疗机构合作" value="1"></el-option>
                  <el-option label="未开展" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接收异地老年人:">
                <el-select
                  v-model="addForm.isElderlyOtherPlaces"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="统一社会信用代码:">
                <el-input
                  v-model="addForm.socialCreditCode"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="运营时间:">
                <el-date-picker
                  v-model="addForm.operationTime"
                  type="datetime"
                  placeholder="请选择时间"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 250px"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="兴办主体:">
                <el-select
                  v-model="addForm.initiatingBody"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="省级民政部门" value="1"></el-option>
                  <el-option label="地级民政部门" value="1"></el-option>
                  <el-option label="县级民政部门" value="1"></el-option>
                  <el-option label="单位,企业或社团" value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="具备医疗资质:" label-width="180px">
                <el-select
                  v-model="addForm.medicalQualifications"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="具备医保定点定点资格:" label-width="180px">
                <el-select
                  v-model="addForm.insuranceQualification"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="养老机构设立许可证编码:" label-width="180px">
                <el-input
                  v-model="addForm.institutionAgreeNumber"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构代码证编号:" label-width="180px">
                <el-input
                  v-model="addForm.institutionalCardNumber"
                  placeholder="请输入"
                  style="width: 250px"
                ></el-input>
              </el-form-item>
              <el-form-item label="登记性质:" label-width="180px">
                <el-select
                  v-model="addForm.registrationNature"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="营利" value="1"></el-option>
                  <el-option label="非营利" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="投资额:" label-width="180px">
                <el-input
                  v-model="addForm.investmentAmount"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <span style="color: #409eff">场地信息</span>
          <p class="hengxian"></p>
          <div class="addBox">
            <div>
              <el-form-item label="房屋产权:">
                <el-select
                  v-model="addForm.housingProperty"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="自有" value="1"></el-option>
                  <el-option label="租赁" value="2"></el-option>
                  <el-option label="其他" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单人间数:">
                <el-input
                  v-model="addForm.singleRoomNumber"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="三人间数:">
                <el-input
                  v-model="addForm.tripleRoomNumber"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="房间总数:">
                <el-input
                  v-model="addForm.elderlyRoomNumber"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="建筑面积(平方米):">
                <el-input
                  v-model="addForm.builtArea"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="房屋类型:">
                <el-select
                  v-model="addForm.housingType"
                  placeholder="请选择"
                  style="width: 250px"
                >
                  <el-option label="楼房" value="1"></el-option>
                  <el-option label="平房" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="双人间数:">
                <el-input
                  v-model="addForm.doubleRoomNumber"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="多人间数:">
                <el-input
                  v-model="addForm.multiplayerRoomNumber"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
              <el-form-item label="占地面积(平方米):">
                <el-input
                  v-model="addForm.coverage"
                  placeholder="请输入"
                  style="width: 250px"
                  type="number"
                  :min="0"
                  oninput="if(value<0)value=''"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <!-- 获奖信息 -->
      <div v-show="controlAddContent == 3">
        <div style="height: 20px"></div>
        <div class="table-wrapper">
          <el-table
            :data="addForm.prizeList"
            style="width: 100%"
            :header-cell-style="{
              background: '#4578AF',
              color: '#fff',
              borderColor: '#4578AF',
            }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="100"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="name"
              label="名称"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="number"
              label="编号"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
              prop="time"
              label="时间"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 监控信息 -->
      <div v-show="controlAddContent == 4">
        <div style="height: 20px"></div>
      </div>
    </el-dialog>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-service>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import Highcharts from "highcharts/highstock"
import Highcharts3D from "highcharts/highcharts-3d"
import baseURL from "@/api/baseURL"
import exportVue from "@/utils/exportVue"
import addService from "./addService.vue"
Highcharts3D(Highcharts)
export default {
  components: {
    addService,
  },
  data() {
    return {
      vodelist: [
        {
          sequence: "1",
          channel: "1",
          token: "1",
        },
        {
          sequence: "1",
          channel: "1",
          token: "1",
        },
      ],
      companyIndex: 0,
      serviceState: false,
      serviceInfo: {},
      tableData: [],
      grapIndex: 0,
      videoUrl: "",
      normalInfo: {},
      addForm: {},
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      markers: [],
      recMap: null,
      recIsMap: true,
      bullData: [],
      ruyuanOldMan: "0",
      staffCount: "0",
      chuyuanOldMan: "0",
      ruyuanOldMan1: "0",
      outtime: "0",
      builtArea: "",
      houseNum: "",
      alltotal: "",
      qingjia: "0",
      isMasked: false,
      maskdata: {},
      zhylydata: [],
      dialogVisible: false,
      dialogVisible1: false,
      controlAddContent: 1,
      ylydata: "0", //智慧养老院数据
      dataIds: [],
      photo: [],
      nation: [
        //民族
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
      ],
      actionUrl: "", // 图片上传地址
      accessKey: "f53a1def26d34d6dbdc91a6b70dbd9b2",
      accessSecret: "70d7c4cf7dd218786a57d0bf95f38d47",
      control: "",
      titleList: [
        {
          id: "1",
          name: "基本信息",
        },
        {
          id: "2",
          name: "运营信息",
        },
        {
          id: "3",
          name: "获奖信息",
        },
        // {
        //     id: "4",
        //     name: "监控信息",
        // },
      ],
    }
  },
  created() {
    this.actionUrl =
      baseURL + "/jgyl/controller/uploadController/info/uploadPhoto"
    exportVue.$on("dataIds", (data) => {
      if (data) {
        this.dataIds = data
      }
    })
  },
  watch: {
    dataIds(val) {
      if (val) {
        this.getElderly(val)
        this.getOldhospital(val)
        this.getAge(val)
        this.getaskLeave(val)
        this.getOutTime(val)
        this.getHouse(val)
        this.record(val)
        this.getvodes(val)
      }
    },
  },
  async mounted() {
    this.getOrg()
    // 年龄分布
    this.getAge()
    //食品安全
    //this.getplayerCon()

    //整改记录
    this.record()
    this.getvodes()
    //请假接口数据
    await this.getaskLeave()
    await this.getOutTime() //逾期
    await this.getHouse() //房屋面积
    //this.echartAge() //年龄分析

    // await this.loadmap().then(() => {
    await this.getElderly()
    //     this.getOldhospital()
    // })
    // await this.getDistrictss("341100")
    //监控
    // this.getvode()
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  methods: {
    getvodes(dataIds) {
      this.vodelist = [
        {
          sequence: "1",
          channel: "1",
          token: "1",
        },
        {
          sequence: "1",
          channel: "1",
          token: "1",
        },
      ]
      this.$http
        .request({
          url: "/ypt/admin/monitorManagement/info/getMonitor",
          method: "POST",
          data: {
            flag: 8,
            dataIds: dataIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content.length > 0) {
              this.vodelist = res.content
            } else {
              this.vodelist = [
                {
                  sequence: "1",
                  channel: "1",
                  token: "1",
                },
                {
                  sequence: "1",
                  channel: "1",
                  token: "1",
                },
              ]
            }
          }
        })
    },
    closeInfo() {
      this.isMasked = false
      this.maskInfo = {}
    },
    closeDialog() {
      this.photo = []
      this.controlAddContent = 1
      this.$refs["addFormRef"].resetFields()
      // this.reload();
    },
    //整改记录
    record(dataIds) {
      this.bullData = []
      request({
        url: "/jgyl/admin/rectification/info/findList1",
        method: "POST",
        data: {
          pageNo: "1",
          pageSize: "10",
          dataIds: dataIds,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          if (res.content != null) {
            this.bullData = res.content.list
          } else {
            this.bullData = []
          }
        }
      })
    },
    // 取消查看
    cancleService(state) {
      this.serviceState = false
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    getOrg() {
      const self = this
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then(async (res) => {
          if (res.code == 200) {
            this.normalInfo = res.content

            if (res.content.latitude && res.content.longitude) {
              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(res.content.longitude, res.content.latitude)
                  this.getElderly()
                  this.getOldhospital()
                })
              }, 30)
            } else {
              let provinceList = [],
                cityList = [],
                areaList = [],
                streetList = [],
                communityList = [],
                longitude = "",
                latitude = ""
              let province = await this.getDistricts()
              provinceList = province.districtList
              if (this.normalInfo.provinceId) {
                let city = await this.getDistricts(this.normalInfo.provinceId)
                cityList = city.districtList
              }
              if (this.normalInfo.cityId) {
                let area = await this.getDistricts(this.normalInfo.cityId)
                areaList = area.districtList
              }
              if (this.normalInfo.areaId) {
                let street = await this.getStreetList(this.normalInfo.areaId)
                streetList = street
              }
              if (this.normalInfo.streetId) {
                let community = await this.getCommityList(
                  Number(this.normalInfo.streetId)
                )
                communityList = community
              }
              if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
              ) {
                provinceList.forEach((item) => {
                  if (item.adcode == this.normalInfo.provinceId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                    console.log()
                  }
                })
              } else if (this.normalInfo.orgLevel == 2) {
                cityList.forEach((item) => {
                  if (item.adcode == this.normalInfo.cityId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (this.normalInfo.orgLevel == 3) {
                areaList.forEach((item) => {
                  if (item.adcode == this.normalInfo.areaId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
              ) {
                streetList.forEach((item, index) => {
                  if (item.adcode + index == this.normalInfo.streetId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              }

              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(longitude, latitude)
                  this.getElderly()
                  this.getOldhospital()
                })
              }, 30)
            }
            var polygonArr = []
            if (res.content.pointPosition) {
              res.content.pointPosition.split(",").forEach((e) => {
                polygonArr.push(e.split(":"))
              })
            }
            var polygon = new AMap.Polygon({
              map: self.myMap,
              path: polygonArr, //设置多边形边界路径
              strokeColor: res.content.gridColour ? res.content.gridColour : "", //线颜色
              strokeOpacity: 0.2, //线透明度
              strokeWeight: 3, //线宽
              fillColor: res.content.gridColour ? res.content.gridColour : "", //填充色
              fillOpacity: 0.35, //填充透明度
              extData: {
                name: res.content.gridColour ? res.content.orgName : "",
              },
            })
            this.polygon = polygon
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //加载地图
    loadmap(longitude, latitude) {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("serveMap", {
          resizeEnable: true,
          zoom: 4,
          // postion: [longitude, latitude],
          mapStyle: "amap://styles/blue",
        })
        if (
          this.$store.state.orgAreaLevel == 1 ||
          this.$store.state.orgAreaLevel == 2 ||
          this.$store.state.orgAreaLevel == 3
        ) {
          let cities = [this.$store.state.orgAreaName]
          for (let i = 0; i < cities.length; i++) {
            self.areaBG(self.myMap, cities[i])
            // self.myMap.setZoom(8)
            self.myMap.setZoomAndCenter(6, [longitude, latitude])
          }
        } else if (
          this.$store.state.orgAreaLevel == 4 ||
          this.$store.state.orgAreaLevel == 5
        ) {
          console.log("社区，街道", this.$store.state.orgId)
          if (this.$store.state.orgId != 0) {
            this.$http
              .request({
                url: "/rbac/admin/org/info/findOrgById",
                method: "POST",
                data: {
                  id: this.$store.state.orgId,
                },
              })
              .then((res) => {
                var polygonArr = []
                res.content.pointPosition.split(",").forEach((i) => {
                  polygonArr.push(i.split(":"))
                })
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                console.log(polygonArr)
                let maxlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlng =
                    maxlng < polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : maxlng
                }
                let minlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlng =
                    minlng > polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : minlng
                }
                let lngs =
                  parseInt(minlng) + (parseInt(maxlng) - parseInt(minlng)) / 2
                let maxlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlat =
                    maxlat < polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : maxlat
                }
                let minlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlat =
                    minlat > polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : minlat
                }
                let lats =
                  parseInt(minlat) + (parseInt(maxlat) - parseInt(minlat)) / 2
                self.myMap.setZoomAndCenter(7, [lngs, lats])
                // self.myMap.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                self.polygon.setMap(self.myMap)
              })
          }
        }
        resolve()
      })
    },
    areaBG(map, cityName) {
      console.log(cityName, "cityName")
      AMap.service("AMap.DistrictSearch", function () {
        let opts = {
          subdistrict: 0,
          extensions: "all",
          level: "district", // 查询行政级别为市
        }
        // 实例化DistrictSearch
        let district = new AMap.DistrictSearch(opts)
        district.setLevel("district")
        // 行政区查询
        district.search(`${cityName}`, function (status, result) {
          // 获取边界信息
          let bounds = result.districtList[0].boundaries
          let polygons = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              // 生成行政区划polygon
              let polygon = new AMap.Polygon({
                map: map,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
              })
              polygons.push(polygon)
              console.log(polygon)
            }
          }
        })
      })
    },
    //获取监控链接
    getvode() {
      fetch("https://open.ys7.com/api/lapp/token/get", {
        method: "POST", // or 'PUT'
        body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          this.control = res.data.accessToken
        })
    },
    //渲染区域信息
    getDistrictss(city, chooseCity = "") {
      return new Promise((resolve, rejcet) => {
        let self = this
        //根据市获取下一级行政区
        let opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let tempArr = []
        let district = new AMap.DistrictSearch(opts) //注意：需要使用插件同步下发功能才能这样直接使用
        district.search(city, function (status, result) {
          if (status == "complete") {
            result.districtList[0].districtList.forEach((item) => {
              tempArr.push(item.name)
            })
            console.log(tempArr, chooseCity, "信息")
            if (!chooseCity) {
              tempArr.forEach((item, index) => {
                self.renderPolygon(district, item, index)
              })
            } else {
              tempArr.forEach((item, index) => {
                if (item == chooseCity) {
                  self.renderPolygon(district, item, index)
                } else {
                  console.log("没有当前区域")
                }
              })
            }
            resolve()
          }
        })
      })
    },
    //渲染行政区边界
    renderPolygon(district, item, index) {
      let self = this
      let color = [
        "#f73131",
        "#fff816",
        "#ff16d8",
        "#709438",
        "#25A5F7",
        "#315EFB",
        "#771CAA",
        "#045206",
        "#6ec55e",
        "#e8ac00",
        "#f77325",
        "#1d15a0",
        "#39fda2",
      ]
      self.myMap.remove(self.polygons)
      self.polygons.length = []
      district.search(item, function (status, result) {
        let bounds = result.districtList[0].boundaries
        self.polygon = null
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.4,
              fillColor: color[index],
              strokeColor: color[index],
              strokeStyle: item,
            })
            self.polygons.push(self.polygon)
          }
        }
        // self.polygon.on("click", function (e) {
        //     self.myMap.remove(self.polygons)
        //     let polygon = new AMap.Polygon({
        //         strokeWeight: 1,
        //         path: e.target.w.path,
        //         fillOpacity: 0.4,
        //         fillColor: e.target.w.strokeColor,
        //         strokeColor: e.target.w.strokeColor,
        //     })
        //     self.polygons.push(polygon)
        //     self.myMap.add(polygon)
        //     // self.map.setFitView(polygon);
        //     self.myMap.setZoom(10)
        // })
        self.myMap.add(self.polygons)
        self.myMap.setFitView(self.polygons) //视口自适应
      })
    },
    getServeTypes(type, num) {
      console.log(type, num)
      const self = this
      this.myMap.remove(this.markers)
      this.markers = []
      if (type == 1 && num > 0) {
        this.getElderly()
      } else if (type == 2 && num > 0) {
        this.getOldhospital()
      }
    },
    //智慧养老院
    getElderly(dataIds) {
      this.myMap.remove(this.markers)
      this.markers = []
      this.$http
        .request({
          url: "/jgyl/admin/institute/info/findList",
          method: "POST",
          data: {
            pageSize: 100,
            pageNo: 1,
            state: 1,
            dataIds: dataIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.ylydata = res.content.count
            if (res.content != null) {
              if (res.content.list.length > 0) {
                res.content.list.forEach((item, index) => {
                  item.tubiao = require("../../../assets/supervise/zhyly.png")
                  item.typeId = "zhihuiData"
                  item.latitude = Number(item.addressLat)
                  item.longitude = Number(item.addressLng)
                })
                this.goPoint(res.content.list)
              }
            }
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    //入院老人打点
    getOldhospital(dataIds) {
      this.myMap.remove(this.markers)
      this.markers = []
      this.$http
        .request({
          url: "/jgyl/admin/register/info/findList",
          method: "POST",
          data: {
            pageSize: 100,
            pageNo: 1,
            dataIds: dataIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              if (res.content.list.length > 0) {
                this.ruyuanOldMan1 = res.content.list.length
                res.content.list.forEach((item, index) => {
                  item.tubiao = require("../../../assets/supervise/pold.png")
                  item.typeId = "hospitalData"
                  item.latitude = Number(item.latitude)
                  item.longitude = Number(item.longitude)
                })
                // console.log(res.content.list,'res.content.list')
                this.goPoint(res.content.list)
              }
            }
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    goPoint(data) {
      const self = this
      console.log(data, "坐标集合")
      data.forEach((item) => {
        if (item.longitude && item.latitude) {
          let marker = new AMap.Marker({
            position: [item.longitude, item.latitude],
            icon: new AMap.Icon({
              image: item.tubiao,
              size: new AMap.Size(50, 50), //图标大小
              imageSize: new AMap.Size(20, 20),
            }),
          })
          self.markers.push(marker)
          marker.on("click", (e) => {
            if (item.typeId == "zhihuiData") {
              //this.isMasked = true
              this.dialogVisible = true
              this.getById(item.id)
            }
            if (item.typeId == "hospitalData") {
              console.log("00000-----")
              this.serviceState = true
              this.serviceInfo = {
                id: item.id,
                state: true,
                title: "查看",
              }
            }
          })
        }
      })
      self.myMap.add(self.markers)
      // self.myMap.setZoom(4)
    },
    getById(id) {
      this.$http
        .request({
          url: "/jgyl/admin/institute/info/get",
          method: "POST",
          data: {
            id: id,
          },
        })
        .then(async (res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.addForm = res.content
            }
          } else {
            this.$message({
              message: "根据ID获取信息失败",
              type: "error",
            })
          }
        })
    },
    changeIdx(id) {
      this.controlAddContent = id
    },
    dialogVisibleClone() {
      this.auditDialogVisible = false
      this.$refs.addformRef.resetFields()
    },
    // 入院老人柱形图
    echartHosiptial(mandata, womandata) {
      console.log(mandata, womandata)
      let mayCharts = this.$echarts.init(document.getElementById("hospitalOld"))
      let option
      option = {
        color: ["#2B94F2", "#FBB828"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["男", "女"],
          left: "5%",
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "9%",
          top: "18%",
          right: "3%",
          bottom: "18%",
          containLabel: false,
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: { show: false },
          },
        },

        xAxis: [
          {
            type: "category",
            data: [
              "60岁以下",
              "60岁-69岁",
              "70岁-79岁",
              "80岁-89岁",
              "90岁以上",
            ],
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 1, //这里是为了突出显示加上的
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 45,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 1, //这里是为了突出显示加上的
              },
            },
          },
        ],
        series: [
          {
            name: "男",
            type: "bar",
            data: mandata,
          },
          {
            name: "女",
            type: "bar",
            data: womandata,
          },
        ],
      }

      option && mayCharts.setOption(option)
    },
    //请假统计
    getaskLeave(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findQingJiaCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.qingjia = res.content.qingjia
          } else if (res.content == null) {
            this.qingjia = 0
          }
        }
      })
    },
    //逾期未归
    getOutTime(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findOutTimeCount",
        method: "POST",
        data: { dataIds: dataIds },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.outtime = res.content.yuqiweigui
          }
        }
      })
    },
    //建筑面积 房屋质量
    getHouse(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findBaseSituationCount",
        method: "POST",
        data: { dataIds: dataIds },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.builtArea = res.content.builtArea
            this.houseNum = res.content.houseNum
          }
        }
      })
    },
    //年龄段占比
    getAge(dataIds) {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findAgeAndYlCount",
        method: "POST",
        data: {
          dataIds: dataIds,
        },
      }).then((res) => {
        let arr = []
        let t = ""
        if (res.code === 200) {
          if (res.content != null) {
            this.chuyuanOldMan = res.content.chuyuanOldMan
            this.ruyuanOldMan = res.content.ruyuanOldMan
            this.staffCount = res.content.staffCount

            let agedata = []
            this.agedata = [
              {
                value: res.content.oldage60under,
                name: "60岁以下",
              },
              { value: res.content.oldage60, name: "60-69岁" },
              { value: res.content.oldage70, name: "70-79岁" },
              { value: res.content.oldage80, name: "80-89岁" },
              { value: res.content.oldage90, name: "90岁以上" },
            ]
            this.echartAge(this.agedata) //年龄段分配
            let zilidata
            this.zilidata = [
              {
                value: res.content.selfCare0,
                name: "较差，完全需要别人照顾",
              },
              {
                value: res.content.selfCare1,
                name: "一般，有些事情需要别人照顾",
              },
              {
                value: res.content.selfCare2,
                name: "较好，一般不需要别人照顾",
              },
              {
                value: res.content.selfCare3,
                name: "很好，还可以照顾别人",
              },
            ]
            this.echartMoney(this.zilidata) //自理情况
            let mandata = []
            this.mandata = [
              res.content.manage60under,
              res.content.manage60,
              res.content.manage70,
              res.content.manage80,
              res.content.manage90,
            ]
            let womandata = []
            this.womandata = [
              res.content.womanage60under,
              res.content.womanage60,
              res.content.womanage70,
              res.content.womanage80,
              res.content.womanage90,
            ]
            this.echartHosiptial(this.mandata, this.womandata)
          }
        }
      })
    },
    //年龄段饼状图
    echartAge(agedata) {
      let mayChart1 = this.$echarts.init(document.getElementById("ageData"))
      let option
      option = {
        color: [
          "#3BA0FF",
          "#2CD1C0",
          "#4DCB73",
          "#FAD337",
          "#F2637B",
          "#975FE4",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "55%", //图例距离左的距离
          y: "center", //图例上下居中
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "0%",
          top: "18%",
          right: "12%",
          bottom: "18%",
          containLabel: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["30%", "50%"],
            radius: ["30%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: agedata,
          },
        ],
      }
      option && mayChart1.setOption(option)
    },

    //自理情况占比
    echartMoney(data) {
      let mayChart2 = this.$echarts.init(document.getElementById("moneyData"))
      let option
      option = {
        color: ["#FA7093", "#2B94F2", "#FBB828", "#2CD1C0", "#E8BDF3"],
        title: {
          text: "自理情况占比",
          left: "4%",
          top: "0%",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} :  ({d}%)",
        },
        legend: {
          show: false,
        },
        grid: {
          left: "15%",
          top: "20%",
          right: "3%",
          bottom: "18%",
          containLabel: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "60%"],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }
      option && mayChart2.setOption(option)
    },
  },
}
</script>
<style lang="less" scoped>
.homeMain {
  position: relative;
  padding: 0px 12px;
  display: flex;
  max-width: 1920px;
  margin: auto;
  .serveTitle {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding-left: 22px;
    padding-top: 20px;
  }
  .companyImg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .homeLeft {
    flex: 1;
    .map-top {
      width: 100%;
      position: relative;
      height: 58vh;
      .trangle {
        width: 34px;
        height: 34px;
        z-index: 1111;
        position: absolute;
        &.trangle1 {
          left: 0px;
          top: 0px;
        }
        &.trangle2 {
          right: -4px;
          bottom: -4px;
          transform: rotate(180deg);
        }
        &.trangle3 {
          left: 0px;
          bottom: -4px;
          transform: rotate(-90deg);
        }
      }
      .trangleRight {
        width: 217px;
        height: 96px;
        position: absolute;
        right: -4px;
        top: 0px;
        z-index: 12;
      }
      .serveMap {
        border: 2px solid #2785dc;
        width: 100%;
        height: 100%;
      }
    }
    .map-bottom {
      width: 100%;
      height: 31vh;
      position: relative;
      margin-top: 12px;
      overflow: hidden;
      .old-left {
        float: left;
        width: 70%;
        p {
          color: #fff;
          text-align: left;
          font-size: 18px;
          margin-top: 12px;
          margin-bottom: 14px;
          margin-left: 12px;
        }
        .analyse {
          display: flex;
          .analyse-left {
            flex: 1;
            #ageData {
              width: 100%;
              margin-top: 10px;
              height: 20vh;
            }
          }
          .analyse-right {
            flex: 1;
            #moneyData {
              width: 100%;
              margin-top: 10px;
              height: 20vh;
            }
          }
        }
      }
      .old-right {
        float: left;
        width: 30%;
        p {
          color: #fff;
          text-align: left;
          font-size: 18px;
          margin-top: 12px;
          margin-bottom: 14px;
          margin-right: 12px;
        }
        ul {
          overflow: hidden;
          li {
            float: left;
            width: 46%;
            margin-right: 4%;
            p {
              color: #fff;
              font-size: 16px;
            }
            div {
              width: 67px;
              height: 77px;
              position: relative;
              line-height: 77px;
              text-align: center;
              span {
                color: #fff;
                font-size: 15px;
                position: absolute;
                left: 0;
                right: 0;
                z-index: 99;
              }
              img {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                right: 0;
                width: 100%;
                height: 100%;
              }
            }
          }
          li:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .homeCenter {
    width: 27%;
    margin-left: 12px;
    .serveObj {
      width: 100%;
      height: 46vh;
      position: relative;
      .serveObjTop {
        padding-top: 18%;
        height: 30vh;
        position: relative;
        z-index: 99;
        .sertitle {
          color: #fff;
          font-size: 18px;
          margin-left: 20px;
        }
        .today {
          margin-top: 3%;
          margin-bottom: 5%;
        }
        .serveBox {
          padding: 20px 15px;
          display: flex;
          justify-content: space-between;
          height: 67px;
          .serveOther {
            flex: 1;
            text-align: center;
            cursor: pointer;
            img {
              width: 34px;
              height: 32px;
              margin-left: -12%;
              margin-right: 20px;
            }
            p {
              display: inline-block;
              .name {
                color: #fff;
                font-size: 12px;
                text-align: center;
                display: inline-block;
                margin-bottom: 5px;
              }
              .nums {
                font-size: 20px;
                color: #fa7093;
                font-weight: bold;
                display: inline-block;
                margin-top: 8px;
              }
            }
          }
          .serveItem {
            position: relative;
            width: 151px;
            height: 67px;
            .name {
              width: 80px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              padding-left: 60px;
            }
            .nums {
              font-size: 20px;
              font-weight: bold;
              width: 80px;
              text-align: center;
              line-height: 38px;
              padding-left: 60px;
              color: #fff;
              padding-top: 4px;
            }
            // background: #01b1ff;
            &.serveItem1 {
              margin: 0px 15px;
            }
          }
        }
      }
    }
    .demographic {
      width: 100%;
      position: relative;
      margin-top: 12px;
      height: 43vh;
      #hospitalOld {
        width: 100%;
        margin-top: 10px;
        height: 32vh;
      }
    }
  }
  .homeRight {
    width: 27.5%;
    margin-left: 12px;
    .companyServe {
      width: 100%;
      height: 32vh;
      position: relative;
      overflow: hidden;
      .compayTop {
        position: relative;
        z-index: 1000;
        display: flex;
        align-items: center;
        .companyName {
          flex: 1;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          padding-left: 20px;
          margin-top: 5%;
        }
        .companyTab {
          padding: 15px 20px;
          span {
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #6ebcff;
            font-size: 14px;
            border: 2px solid rgba(46, 158, 255, 0.8);
            line-height: 28px;
            border-radius: 4px;
            width: 114px;
            &.curIndex {
              background: #2889fe;
              color: #fff;
            }
          }
        }
      }
      .companyHead {
        background: linear-gradient(to right, #01b1ff, #2e9eff);
        margin: 12px 12px 0px;
        display: flex;
        line-height: 40px;
        color: #fff;
        font-size: 15px;
        height: 40px;
        text-align: center;
        .item {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .item2 {
          flex: 2;
        }
      }
      .nocolorHead {
        background: none;
        margin-top: 0;
      }

      .compayDes {
        height: 14vh;
        overflow: hidden;
        padding: 12px;
        margin-top: 12px;
        .desItem {
          display: flex;
          text-align: center;
          align-items: center;
          font-size: 14px;
          line-height: 24px;
          color: #01b1ff;
          .item {
            flex: 1;
          }
          .item2 {
            flex: 2;
          }
        }
      }
    }
    .serveStation {
      margin-top: 12px;
      position: relative;
      width: 100%;
      height: 57vh;
      overflow: hidden;
      .over {
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .prism-player {
          height: 200px;
        }
      }
      .over::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
.oversHead::-webkit-scrollbar {
  display: none;
}
.oversHead {
  overflow-y: scroll;
  height: 19vh;
  position: absolute;
  left: 0;
  right: 0;
  .companyHead {
    span {
      height: 20px;
      line-height: 20px;
      display: inline-block;
    }
  }
}
.maskModel {
  width: 650px;
  height: 630x;
  background: rgba(2, 29, 54, 1);
  border: 1px solid rgba(110, 188, 255, 1);
  position: absolute; /*参照物是父容器*/
  left: 50%;
  top: 5%;
  transform: translateX(-50%); /*百分比的参照物是自身*/
  z-index: 2000;
  .yearMoney {
    display: flex;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    padding: 0px 12px;
    background: rgba(0, 60, 125, 1);
    .name {
      color: #fff;
      font-size: 16px;
      flex: 1;
    }

    .maskClose {
      width: 19px;
      height: 19px;
      position: relative;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
  }
  .noflex {
    display: block;
  }
  .ruyuanInfo {
    margin: 20px 18px;
    li {
      width: 100%;
      color: #fff;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }
}
.personFlex {
  display: flex;
  align-items: center;
  padding: 30px 15px;
  .img {
    width: 150px;
    height: 150px;
    margin-right: 15px;
    margin-top: 5px;
  }
  .personConent {
    flex: 1;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 30px;
  }
}
.maskTab {
  background: linear-gradient(to right, #01b1ff, #2e9eff);
  margin: 12px 12px 0px;
  display: flex;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  height: 40px;
  text-align: center;
  .item {
    flex: 1;
  }
  .item2 {
    flex: 2;
  }
}
.maskDes {
  margin: 12px 12px 16px;
  // display: flex;
  height: 28vh;
  position: relative;
  z-index: 20;
  overflow: hidden;
  line-height: 0px;
  .desItem {
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 14px;
    line-height: 25px;
    cursor: pointer;
    color: #01b1ff;
    .item {
      flex: 1;
      .centerTip,
      .centerTip1 {
        width: 100px;
        display: inline-block;
        padding: 0 10%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .centerTip1 {
        width: 80px;
      }
    }
    .item2 {
      flex: 2;
    }
  }
}
.maksPage {
  margin: 0 12px;
  /deep/.el-pagination__total,
  /deep/.el-pagination__jump {
    color: #fff;
  }
}
.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #5186bf;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #5186bf;
}

.changeColor > div:first-child {
  background-color: #3333ff;
}

.changeColor > div:nth-child(2) {
  color: #3333ff;
}

.changeColor > div:last-child {
  background-color: #3333ff;
}

.name-bottom {
  text-align: center;
  color: #336397;
}

.addBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.uploadAvatar {
  margin-left: 90px;
}
.avatar {
  width: 100%;
  height: 100%;
}
/deep/.el-dialog__header {
  padding: 20px;
  background: #003c7d;
  .el-dialog__title {
    color: #fff;
  }
}
/deep/.el-dialog__body {
  background: #003c7d;
  opacity: 0.8;
}
/deep/.el-input.is-disabled .el-input__inner {
  background-color: #003c7d;
  border-color: #82beff;
  color: #fff;
  opacity: 0.8;
}
/deep/.el-form-item__label {
  color: #82beff;
}
/deep/.el-upload--picture-card {
  background-color: #003c7d;
  border: 1px dashed #82beff;
}
/deep/.uploadBtn {
  color: #336397;
  margin-top: 12px;
}
.hengxian {
  height: 2px;
  width: 100%;
  background: #336397;
  margin: 10px 0 25px;
}
/deep/ .el-table,
.el-table__expanded-cell {
  background-color: #4578af !important;
  color: #fff;
}
/deep/.el-table th,
.el-table tr {
  border: 0 !important;
  background-color: #4578af !important;
  color: #fff;
}
/deep/.table-wrapper .el-table--border tr,
td {
  border: none !important;
  color: #fff;
}
/deep/.table-wrapper .el-table::before {
  height: 0;
}
/deep/.el-table th {
  background-color: #336397 !important;
  pointer-events: none;
}
/deep/.el-table tr {
  background-color: #336397 !important;
  pointer-events: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #336397;
}
/deep/.el-pagination {
  margin-top: 12px;
}
/deep/.el-pagination__total {
  color: #fff;
}
/deep/.el-pagination button:disabled {
  background-color: #4578af;
}
/deep/.el-pager li.active {
  color: #409eff;
}
/deep/.el-dialog,
.el-pager li {
  background: #4578af;
}
/deep/.el-pagination__jump {
  color: #fff;
}
</style>
